/**
 * 로그인 및 역할 기반 라우팅
 *
 * Firebase Auth 이메일 형식: {입력 ID}@toss.kr
 * 역할은 Firestore User/Auth/{Master|Branch|Teacher} 문서 존재 여부로 판별
 */
import { ChangeEvent, useState } from "react";
import useFirebaseAuth from "shared/hooks/useFirebaseAuth";
import { useNavigate } from "react-router-dom";
import useFirestore from "shared/hooks/useFirestore";

const useLogin = () => {
    const {login} = useFirebaseAuth();
    const navigate = useNavigate();
    const [isOpenModal, setIsOpenModal] = useState(false);
    const {readFirestoreOneDoc} = useFirestore();
    type form = {id:string; pw:string};
    const [inputs, setInputs] = useState<form>({
        id:"",
        pw:""
    });

    const onLoginClick = async() =>{
        // Auth 성공 시 uid를 sessionStorage에 저장 — 이후 모든 훅이 이 값으로 사용자 식별
        const uid = await login(`${inputs.id}@toss.kr`, inputs.pw).then(res => {
            return res.uid;
        }).catch(err => {
            console.log(err);
            return null;
        })
        if(uid){
            sessionStorage.setItem("uid", uid);
        }else{
            setIsOpenModal(true);
            return ;
        }
        const authority = await checkAuthority(uid);
        if(authority === 0){
            navigate("/owner/home");
        }else if(authority === 1 || authority === 2){
            navigate("/teacher/home");
        }
    }

    /** Master → Branch → Teacher 순으로 조회. 여러 문서가 있으면 마지막 매칭이 우선 */
    const checkAuthority = async(uid:string) => {
        let authority = 4; // 4 = 미인증 (Firestore에 역할 문서 없음)
        authority = await readFirestoreOneDoc("User/Auth/Master", uid).then(res => {
            return res.exists() ? 0 : authority; 
        })

        authority = await readFirestoreOneDoc("User/Auth/Branch", uid).then(res => {
            return res.exists() ? 1 : authority; 
        })

        authority = await readFirestoreOneDoc("User/Auth/Teacher", uid).then(res => {
            return res.exists() ? 2 : authority; 
        })

        return authority;
    }

    const onChange = (e:ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setInputs(prevState => ({
            ...prevState,
            [name]:value
        }))
    }

    const onModalConfirmClickHandler = () => {
        setIsOpenModal(false);
    }

    return {
        inputs, 
        onChange, 
        onLoginClick, 
        isOpenModal, 
        onModalConfirmClickHandler
    }
}

export default useLogin;